import API from '@/api/callApi.js';
import endpoints from '@/api/endpoints';

export default {
    namespaced: true,
    state: {
        establishmentReady: false,
        loaded: false,
        scheduleLoaded: false,
        establishment: null,
        scheduleEstablishment: null
    },
    mutations: {
        setEstablishmentLoaded(state, value) {
            state.loaded = value;
        },
        setScheduleEstablishmentLoaded(state, value) {
            state.scheduleLoaded = value;
        },
        setEstablishmentData(state, value) {
            state.establishment = value;
        },
        setScheduleEstablishment(state, value) {
            state.scheduleEstablishment = value;
        }
    },
    actions: {
        establishmentData({
            commit
        }, parameters) {
            API.makeGet(endpoints.baseURL + endpoints.endpoints.establishment, null, true).then(response => {
                if (response.data.payload.length > 0) {
                    commit('setEstablishmentData', response.data.payload[0]);
                    // console.info('repsonse', response.data.payload);
                } else {
                    commit('setEstablishmentData', {
                        id: null,
                        name: null,
                        surface: null,
                        address: null,
                        country: null,
                        city: null,
                        postal_code: null,
                        compagny_logo: null
                    });
                }
                commit('setEstablishmentLoaded', true);
                parameters.success();
            });
        },

        scheduleEstablishmentData({
            commit
        }, parameters) {
            API.makeGet(endpoints.baseURL + API.processUrl(endpoints.endpoints.scheduleEstablishment, {'establishment_id': parameters.params}), {
                'establishment_id': parameters.params
            }, true).then(response => {
                if (response.data.payload.length > 0) {
                    commit('setScheduleEstablishment', response.data.payload);
                } else {
                    commit('setScheduleEstablishment', {
                        day: "",
                        opening_hours: "",
                        hour_break_start: "",
                        hour_break_end: "",
                        closing_hours: "",
                        is_open: false,
                        midday_break: false
                    });
                }
                commit('setScheduleEstablishmentLoaded', true);
                parameters.success(response.data.payload);

            });
        },

        createScheduleEstablishment(
            {
                commit,
                dispatch
            },
            params
        ) {
            API.makePost(endpoints.baseURL + endpoints.endpoints.createScheduleEstablishment, {
                'params': JSON.stringify(params.parameters)
            }, true).then(response => {
                commit('setScheduleEstablishment', response.data.payload);
                commit('ui/triggerAlert', {
                    type: 'success',
                    msg: 'Établissement créé'
                }, {root: true});
                params.success(response.data.payload);
            }).catch(error => {
                let m = error.response ? error.response.data : (error.request ? error.request.response : error.message);
                commit('ui/triggerAlert', {
                    type: 'error',
                    msg: 'L\'établissement n\'a pas pu être créé '
                }, {root: true});
            })
        },

        updateScheduleEstablishment(
            {
                commit,
                state
            },
            params
        ) {
            API.makePost(endpoints.baseURL + API.processUrl(endpoints.endpoints.updateScheduleEstablishment), {
                'params': JSON.stringify(params.parameters)
            }, true).then(response => {
                commit('setEstablishmentData', response.data.payload);
                commit('ui/triggerAlert', {
                    type: 'success',
                    msg: 'Horaires du magasin modifiés'
                }, {root: true});
            }).catch(error => {
                let m = error.response ? error.response.data : (error.request ? error.request.response : error.message);
                commit('ui/triggerAlert', {
                    type: 'error',
                    msg: 'Les horaires n\'ont pas pu être modifiés '
                }, {root: true});
            })
        },

        createEstablishment({
            commit
        }, params) {
            API.makePost(endpoints.baseURL + endpoints.endpoints.createEstablishment, params.parameters, true).then(response => {
                commit('setEstablishmentData', response.data.payload);
                commit('ui/triggerAlert', {
                    type: 'success',
                    msg: 'Établissement créé'
                }, {root: true});
                params.success(response.data.payload);
            }).catch(error => {
                let m = error.response ? error.response.data : (error.request ? error.request.response : error.message);
                commit('ui/triggerAlert', {
                    type: 'error',
                    msg: 'L\'établissement n\'a pas pu être modifié '
                }, {root: true});
            })
        },


        updateEstablishment(
            {
                commit,
                state
            },
            params
        ) {

            let url;

            if (state.establishment.id === null) {

                url = endpoints.baseURL + API.processUrl(endpoints.endpoints.createEstablishment, {establishment_id: params.parameters.id});

            } else {

                url = endpoints.baseURL + API.processUrl(endpoints.endpoints.updateEstablishment, {establishment_id: params.parameters.id});

            }

            let fdata = new FormData();


            fdata.append('name', params.parameters.name);
            fdata.append('surface', params.parameters.surface);
            fdata.append('phone_number', params.parameters.phone_number);
            fdata.append('profile_picture', params.parameters.profile_picture);
            fdata.append('address', params.parameters.address);
            fdata.append('country', params.parameters.country);
            fdata.append('city', params.parameters.city);
            fdata.append('postal_code', params.parameters.postal_code);
            fdata.append('path', params.parameters.path);
            fdata.append('created_at', params.parameters.created_at);
            fdata.append('updated_at', params.parameters.updated_at);
            fdata.append('created_by', params.parameters.created_by);
            fdata.append('updated_by', params.parameters.updated_by);
            fdata.append('compagny_logo', params.parameters.compagny_logo);

            API.makeFormDataPost(url, fdata, true).then(response => { // console.info('response', response);
                commit('setEstablishmentData', response.data.payload);
                commit('ui/triggerAlert', {
                    type: 'success',
                    msg: 'Établissement modifié'
                }, {root: true});
                params.success(response.data.payload);
            }).catch(response => {
                let m = error.response ? error.response.data : (error.request ? error.request.response : error.message);
                commit('ui/triggerAlert', {
                    type: 'error',
                    msg: 'L\'établissement n\'a pas pu être modifié '
                }, {root: true});
            }). finally(response => {
                commit('setEstablishmentData', response.data.payload);
            });

            //     API.makePost(endpoints.baseURL + API.processUrl(endpoints.endpoints.updateEstablishment, { establishment_id : params.parameters.id }),
            //         params.parameters, true)
            //     .then (response => {
            //         // dispatch('establishmentData');
            //         commit('setEstablishmentData', response.data.payload);
            //         commit('ui/triggerAlert', {type:'success', msg:'Établissement modifié'}, { root:true});
            //         params.success(response.data.payload);
            //     })
            //     .catch (error => {
            //         let m = error.response ? error.response.data : (error.request ? error.request.response  : error.message);
            //         commit('ui/triggerAlert', {type:'error', msg:'L\'établissement n\'a pas pu être modifié '}, { root:true});
            //     })
        }
    }

};
